
import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { delivery_form_list } from './lib/form_struct';
import Table from './component/delivery-table.vue';
import UploadFile from './component/upload-file.vue';
import UserDefined from './component/user-defined.vue';
import BatchModifying from './component/batch-modifying.vue';
import { static_options } from './lib/options';
import { delivery_modifying_list } from './lib/modifying';
import { deliveryUpload } from './lib/upload-file';
import { filterOption } from './lib/form_struct';

const _ = {
  deep_clone: require('lodash/cloneDeep')
};
const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_delivery_list: `${FCAPI}/boss/hundun/chuang/delivery`,
  edit_delivery_batch: `${FCAPI}/boss/hundun/chuang/delivery/batch/0`,
  get_custom_config: `${FCAPI}/boss/hundun/chuang/customconfig`,
  edit_custom_config: `${FCAPI}/boss/hundun/chuang/customconfig/0`,
  creat_recruiting_upload: `${FCAPI}/boss/hundun/chuang/delivery/batch`
};

@Component({
  components: { UploadFile, UserDefined, BatchModifying, Table }
})
export default class MissionDetail extends Vue {
  /* eslint-disable */
  @Hundun.State('teacher_list') teacher_list!: any[]; //负责班主任
  @Hundun.State('branch_office') branch_office!: any[]; //分社选项
  @Watch('teacher_list')
  valueChange(newValue: string) {
    this.search_info_list.teacher_id.options = newValue;
    console.log(this.search_info_list.teacher_id.options);

    this.dialog_form_list.teacher_id.options = newValue;
  }

  btn_list: Array<any> = [
    { id: 1, label: '批量修改', type: 'primary' },
    { id: 2, label: '自定义表头', type: 'primary' },
    { id: 3, label: '导入', type: 'primary' },
    { id: 4, label: '导出', type: 'primary' },
    { id: 5, label: '搜索', type: 'primary' },
    { id: 6, label: '清空搜索条件', type: 'link' }
  ];
  is_loading = false;
  data_list = [];
  pagenation_info = { current: 0, limit: 0, total: 0 };
  select_row_key = [];
  user_define_dialog_visible = false;
  modifying_dialog_visible = false;
  user_define_form_list = [];
  download_sign = 0; // 0否，1导出，
  dialog_form_list = _.deep_clone(delivery_modifying_list);
  search_info_list = _.deep_clone(delivery_form_list);
  upload_visible = false;
  user_define_list: any = [];
  filterOption = filterOption;

  // 自定义表头数据
  @Provide('getCustomConfig')
  async getCustomConfig() {
    const res = await this.$axios.get(API.get_custom_config, { params: { channel: 3 } });
    if (res.data.status !== 200) return this.$message.error('自定义表头获取失败！');
    this.user_define_form_list = res.data.data;
    this.user_define_form_list.forEach((element: any) => {
      element.options = element.options.split(',').map((item: any) => ({ value: item }));
    });
    console.log(this.user_define_form_list);
    this.user_define_list = JSON.parse(JSON.stringify(this.user_define_form_list));
    this.user_define_list.forEach((item: any) => {
      item['value'] = undefined;
    });
    console.log(this.user_define_list);
  }
  // 表格select选择
  onSelectChange(select_row_key: any) {
    this.select_row_key = select_row_key;
  }
  // 自定义表头确认
  async UserDefinedOk(list: any, type: number) {
    this.user_define_dialog_visible = false;
    const send_data: any = { channel: 3, add: [], edit: [] };
    list.forEach((element: any) => {
      if (element.type == 1) element.options = '';
      if (element.id) {
        send_data.edit.push(element);
      } else {
        send_data.add.push(element);
      }
    });
    const res = await this.$axios.put(API.edit_custom_config, send_data);
    if (res.status !== 200 && res.data.status != 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getCustomConfig();
    //
  }
  // 自定义取消
  UserDefinedCancel() {
    this.user_define_dialog_visible = false;
  }

  // 确认导入
  async uploadOk(file_list: any) {
    const send_data = deliveryUpload(file_list, { teacher_list: this.teacher_list, ...static_options });
    const res = await this.$axios.post(API.creat_recruiting_upload, { data: send_data.res });
    if (res.data.status != 200) return this.$message.error('导入失败！');
    this.$message.success('导入成功！');
    this.upload_visible = false;
    (this.$refs.table as any).getList();
  }
  // 取消导入
  uploadCancel() {
    this.upload_visible = false;
    //
  }

  // 确认批量修改
  async handleOk(list: any) {
    const send_data = {
      id: this.select_row_key,
      undelivered_module: list.undelivered_module.value.join(','),
      teacher_id: list.teacher_id.value && list.teacher_id.value.join(','),
      class_period: list.class_period.value,
      gender: list.gender.value,
      solution_progress: list.solution_progress.value,
      cover_level: 0
    };
    const res: any = await this.$axios.put(`${API.edit_delivery_batch}`, send_data);
    if (res.status == 200) {
      this.$message.success('批量修改成功！');
      (this.$refs.table as any).getList((this.$refs.table as any).pagenation_info.current);
      this.select_row_key = [];
    }
    this.modifying_dialog_visible = false;
    Object.values(this.dialog_form_list).forEach((element: any) => {
      if (element.key == 'undelivered_module' || element.key == 'teacher_id') {
        element.value = [];
      } else {
        element.value = undefined;
      }
    });
    (this.$refs.table as any).select_row_key = this.select_row_key = [];
  }
  // 取消批量修改
  handleCancel() {
    this.modifying_dialog_visible = false;
    Object.values(this.dialog_form_list).forEach((element: any) => {
      if (element.key == 'undelivered_module' || element.key == 'teacher_id') {
        element.value = [];
      } else {
        element.value = undefined;
      }
    });
  }

  btnClick(val: number) {
    switch (val) {
      case 1:
        if (this.select_row_key.length <= 0) return this.$message.error('请先勾选要批量修改的用户！');
        this.modifying_dialog_visible = true;
        break;
      case 2:
        this.user_define_dialog_visible = true;
        console.log(val);
        break;
      case 3:
        this.upload_visible = true;
        break;
      case 4:
        this.download_sign = 1;
        (this.$refs.table as any).getList(1, this.download_sign);
        break;
      case 5:
        this.download_sign = 0;
        (this.$refs.table as any).getList();
        break;
      case 6:
        Object.keys(this.search_info_list).forEach((key: any) => {
          if (this.search_info_list[key].key == 'income' || this.search_info_list[key].key == 'fee') {
            this.search_info_list[key].value.first = undefined;
            this.search_info_list[key].value.second = undefined;
          } else if (this.search_info_list[key].key == 'birthday_time' || this.search_info_list[key].key == 'teacher_id' || this.search_info_list[key].key == 'cloth_size') {
            this.search_info_list[key].value = [];
          } else this.search_info_list[key].value = undefined;
        });
        this.user_define_list.forEach((element: any) => {
          element.value = undefined;
        });
        (this.$refs.table as any).select_row_key = this.select_row_key = [];
        this.$forceUpdate();
        break;
      default:
        break;
    }
  }
  async created() {
    await this.getCustomConfig();
    // this.search_info_list.teacher_id.options = this.teacher_list;
    // console.log(this.search_info_list.teacher_id.options);

    const arr = ['黄茜', '雷媛媛'];
    if (localStorage['master:profile']) {
      if (!arr.includes(JSON.parse(localStorage['master:profile']).data.name)) {
        this.btn_list = this.btn_list.filter((item: any) => item.id != 2);
      }
    }
    if (localStorage['beta:profile']) {
      if (!arr.includes(JSON.parse(localStorage['beta:profile']).data.name)) {
        this.btn_list = this.btn_list.filter((item: any) => item.id != 2);
      }
    }
  }
}
